import { isNative, platform } from './platform';

export async function applyNativeTheme(dark: boolean): Promise<void> {
  if (!isNative()) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
    if (platform() === 'android') {
      await StatusBar.setBackgroundColor({
        color: dark ? '#171310' : '#f5f3ef',
      });
    }
  } catch {
  }
}

export async function initNativeShell(): Promise<void> {
  if (!isNative()) return;

  if (typeof document !== 'undefined') {
    await applyNativeTheme(
      document.documentElement.classList.contains('dark'),
    );
  }

  try {
    const { Keyboard, KeyboardResize } = await import('@capacitor/keyboard');
    await Keyboard.setResizeMode({ mode: KeyboardResize.Body });
  } catch {
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide();
  } catch {
  }
}
